<div class="inline-spinner"
  [ngStyle]="{ width: width + 'px', height: height + 'px' }">
</div>